import React from "react";
import { Box, Typography } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';

interface OrderMessagesProps {
  messages: any[];
  driverName: string;
}

const OrderMessages: React.FC<OrderMessagesProps> = ({messages, driverName}) => {
      return (
        <>
          {(messages.length > 0) && (<Typography variant="h6" gutterBottom>
            Comments
          </Typography>)}          
          <List>            
          {messages.map((x) =>(           
            x.text ? <ListItem>
              <ListItemAvatar>
                <Avatar>{driverName[0].toUpperCase()}</Avatar>
              </ListItemAvatar>               
              <ListItemText primary={x.text} secondary={"From " + driverName}></ListItemText></ListItem> : 
              <ListItem><img width="100%" src={x.image}></img></ListItem>
          ))
          }
          </List>
        </>
      )
}

export default OrderMessages;